import { render, staticRenderFns } from "./PHistory.vue?vue&type=template&id=76cbc502&scoped=true&"
import script from "./PHistory.vue?vue&type=script&lang=js&"
export * from "./PHistory.vue?vue&type=script&lang=js&"
import style0 from "./PHistory.vue?vue&type=style&index=0&id=76cbc502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cbc502",
  null
  
)

export default component.exports